<!--
 * @Date: 2020-08-03 18:22:33
 * @LastEditors: Mosuzi
 * @LastEditTime: 2020-08-05 10:03:30
 * @Description: In User Settings Edit
 * @Author: Mosuzi
-->
<template>
  <div class="my-todo">
    <cube-scroll
      ref="scroll"
      :data="computeTodoList"
      :options="cubeScrollOptions"
      class="todo-items"
      @pulling-down="onPullingDown"
      @pulling-up="onPullingUp"
    >
      <div v-for="(item, index) in computeTodoList" :key="item['id']" class="card-item" @click="$emit('click-item', item)">
        <list-card
          :columns="computeTodoColumns[index]"
          :data="item"
          @view-detail="viewDetail"
        ></list-card>
        <div v-if="item.haveProcess || item.status === 'DRAFT'" class="process-status">
          <x-svg-icon
            class="process-status-icon"
            :name="'process-' + item.status"
          ></x-svg-icon>
        </div>
      </div>
      <x-empty v-if="computeTodoList.length < 1"></x-empty>
    </cube-scroll>
  </div>
</template>

<script>
import ListCard from '@/components/list-card/list-card.vue'
import TodoCenterMixin from './todo-center.mixin'
import {
  SET_TODO_NUMBER
} from '@/store/tenant.store.js'
import { mapMutations } from 'vuex'
export default {
  components: {
    ListCard
  },
  mixins: [TodoCenterMixin],
  methods: {
    ...mapMutations('tenantModule', {
      setTodoNumber: SET_TODO_NUMBER
    }),
    requested(resp) {
      this.setTodoNumber(resp.total)
    }
  }
}
</script>

<style lang="scss">
.my-todo {
  height: 100%;
  .todo-items {
    // padding-top: .57143rem;
    margin-left: 1.143rem;
    margin-right: 1.143rem;
    height: 100%;
    .card-item {
      position: relative;
      margin-top: .57143rem;
      .process-status {
        position: absolute;
        top: 1rem;
        right: .714rem;
        .process-status-icon {
          .svg-icon {
            width: 3rem !important;
            height: 2.28rem !important;
          }
        }
      }
    }
    .x-empty {
      margin: 40% auto;
    }
  }
}
</style>
